import { render, staticRenderFns } from "./GeneralContent.vue?vue&type=template&id=713b8600&scoped=true&"
import script from "./GeneralContent.vue?vue&type=script&lang=js&"
export * from "./GeneralContent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralContent.vue?vue&type=style&index=0&id=713b8600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b8600",
  null
  
)

export default component.exports